import { render, staticRenderFns } from "./economy.vue?vue&type=template&id=62219d8e&scoped=true&"
import script from "./economy.vue?vue&type=script&lang=js&"
export * from "./economy.vue?vue&type=script&lang=js&"
import style0 from "./economy.vue?vue&type=style&index=0&id=62219d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62219d8e",
  null
  
)

export default component.exports